(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("ng2-alfresco-core"), require("ng2-alfresco-documentlist"), require("rxjs/Observable"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "ng2-alfresco-core", "ng2-alfresco-documentlist", "rxjs/Observable"], factory);
	else if(typeof exports === 'object')
		exports["ng2-alfresco-aos-editonline"] = factory(require("@angular/core"), require("ng2-alfresco-core"), require("ng2-alfresco-documentlist"), require("rxjs/Observable"));
	else
		root["ng2-alfresco-aos-editonline"] = factory(root["@angular/core"], root["ng2-alfresco-core"], root["ng2-alfresco-documentlist"], root["rxjs/Observable"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition